// extracted by mini-css-extract-plugin
export default {"Card":"Card_Card__qf9W2","Stretch":"Card_Stretch__7lRlR","Fixed":"Card_Fixed__ajFqI","Header":"Card_Header__n2cMm","Body":"Card_Body__a78Zm","Scrollable":"Card_Scrollable__Je-Rz"};